import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppLocalizationService {

  constructor(private _datePipe: DatePipe) { }

  public formatDate(date: Date): string {
    return this._datePipe.transform(date, this.getDateFormat())!;
  }

  public formatDateTime(date: Date): string {
    return this._datePipe.transform(date, this.getDateTimeFormat())!;
  }

  public getDateFormat(): string {
    return 'dd/MM/yyyy';
  }

  public getDateTimeFormat(): string {
    return 'dd/MM/yyyy, h:mm:ss a';
  }
}
